var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sidebar"},_vm._l((_vm.items),function(item){return _c('sidebar-menu-item',{key:Math.random(),attrs:{"data":item,"iconType":"svg"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }